import { Type } from "lucide-react";
import type React from "react";
import type { DataFieldText } from "schema/agent";
import { Field } from "./Field";

export interface TextFieldProps {
  field: DataFieldText;
  onChange: (value: string) => void;
}

export const TextField: React.FC<TextFieldProps> = ({ field, onChange }) => {
  return (
    <Field icon={Type} label={field.label} visibleAt={field.visibleAt}>
      <input
        type="text"
        value={field.value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={field.placeholder}
        maxLength={field.maxLength}
        className="w-full h-8 md:h-6 bg-slate-900/50 text-slate-300 md:text-xs px-2 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500"
      />
    </Field>
  );
};
